module.exports = __webpack_public_path__ + "img/37-image-1@2x.48347e42.png";